<div class="dropdown">
  <button
    type="button"
    class="dropdown-btn"
    (click)="toggle()">
    <div class="selected-option-container">
        <span class="btn-text">{{ selectedOption?.label }}</span>
          @if(selectedOption?.badge) {
            <core-badge class="menu-item-badge"
                        [color]="selectedOption?.badge?.color"
                        [label]="selectedOption?.badge?.label">
            </core-badge>
          }
    </div>
    <span class="caret" aria-hidden="true">
      <img src="{{ caretIcon }}" width="8">
    </span>
  </button>

  <ul class="dropdown-list" *ngIf="isOpen">
    <li *ngFor="let option of dropdownOptions"
        (click)="select(option)"
        [ngClass]="{ 'selected-option': option === selectedOption }">
      <div class="label-container">
        <div class="label">{{ option.label }}</div>
        @if (option.badge) {
          <core-badge class="menu-item-badge"
                      [color]="option.badge.color"
                      [label]="option.badge.label">
          </core-badge>
        }
      </div>
      @if (option.description) {
        <div class="description">{{ option.description }}</div>
      }
    </li>
  </ul>
</div>
